/** A cancelled or expired subscription is closed for good: read-only, never reactivated (OPDON refuses any edit). */
export function isClosedSubscription(status) {
    return status === "Canceled" || status === "Expired";
}
